
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080/api/v1';

export const userApi = {
    completeTutorial: async (): Promise<{ tutorialCompleted: boolean }> => {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/users/me/tutorial-completed`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error('Error al actualizar estado del tutorial');
        }

        return response.json();
    },

    updateActiveSalon: async (salonId: string): Promise<void> => {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/users/me/salon/${salonId}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });

        if (!response.ok) {
            throw new Error('Error al actualizar el salón activo');
        }
    },

    deleteAccount: async (password?: string): Promise<void> => {
        const token = localStorage.getItem('token');
        const response = await fetch(`${API_URL}/users/me`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ password })
        });

        if (!response.ok) {
            // Handle error properly
            if (response.status === 403) {
                throw new Error('Contraseña incorrecta');
            }
            const error = await response.json().catch(() => ({}));
            throw new Error(error.message || 'Error al eliminar la cuenta');
        }
    }
};
